(function () {
  var BASE_PROP = '_kaubox_bundle_id';
  var EXTRA_PROP = '_kaubox_zusatz_fuer';
  var GUARD_SOURCE = 'kaubox-cart-guard';
  var running = false;

  function prop(item, key) {
    return item.properties && item.properties[key];
  }

  function cleanupOrphans() {
    if (running) return Promise.resolve(false);
    running = true;
    return fetch('/cart.js')
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var activeBaseBundleIds = {};
        cart.items.forEach(function (item) {
          var bundleId = prop(item, BASE_PROP);
          var isExtra = !!prop(item, EXTRA_PROP);
          if (bundleId && !isExtra) activeBaseBundleIds[bundleId] = true;
        });

        var orphans = cart.items.filter(function (item) {
          var bundleId = prop(item, BASE_PROP);
          var isExtra = !!prop(item, EXTRA_PROP);
          return isExtra && bundleId && !activeBaseBundleIds[bundleId];
        });

        if (orphans.length === 0) return false;

        var chain = Promise.resolve();
        orphans.forEach(function (item) {
          chain = chain.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: item.key, quantity: 0 }),
            });
          });
        });

        return chain.then(function () {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: GUARD_SOURCE });
          }
          return true;
        });
      })
      .catch(function (e) {
        console.error('kaubox-cart-guard:', e);
        return false;
      })
      .finally(function () {
        running = false;
      });
  }

  function init() {
    cleanupOrphans();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === GUARD_SOURCE) return;
        cleanupOrphans();
      });
    }

    document.addEventListener('click', function (e) {
      var el = e.target.closest('a[href="/checkout"], button[name="checkout"], input[name="checkout"]');
      if (el) cleanupOrphans();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
